module.exports = __webpack_public_path__ + "img/ranking_02.2263c266.png";